import {
  AUTH_OPTIONS_VARIANT_GOOGLE,
  AUTH_OPTIONS_VARIANT_GOOGLE_FB_SMS,
  AUTH_OPTIONS_VARIANT_GOOGLE_SMS,
  AUTH_OPTIONS_VARIANT_SMS_FB,
} from 'Store/mfa/constants';

export const FUNNEL_NAME_MFA = 'identity_mfa';

// Two Factor Authentication (2FA)
export const FUNNEL_2FA_V1 = '2fa_v1.0';
export const STEP_EMAIL_INPUT = 'email_input';
export const STEP_EMAIL_OTP = 'email_one_time_password';
export const STEP_GOOGLE_VERIFICATION = 'google_email_verification';
export const CONTEXT_BACK_BUTTON = 'back_button';
export const CONTEXT_FAIL = 'fail';
export const CONTEXT_NOT_SHOWN = 'not_shown';
export const CONTEXT_OPTED_IN = 'opted_in';
export const CONTEXT_OPTED_OUT = 'opted_out';
export const CONTEXT_REQUEST_DENIED = 'request_denied';
export const CONTEXT_REQUEST_PROCESSED = 'request_processed';
export const CONTEXT_SUCCESS = 'success';
export const CONTEXT_UPDATE_EMAIL = 'update_email';
export const ACTION_BACK = 'back';
export const ACTION_CANCEL = 'cancel';
export const ACTION_GOOGLE_SIGN_IN = 'google_sign_in';
export const ACTION_RESEND = 'resend';
export const ACTION_SUBMIT = 'submit';
export const ACTION_VIEW = 'view';
export const ACTION_DISMISS = 'dismiss';
export const ACTION_TAP = 'tap';
export const ACTION_VIEW_NOW_TAP = 'view_now_tap';
export const getEmailOptInContext = (optionShown: boolean, isOptIn: boolean) => {
  if (!optionShown) {
    return CONTEXT_NOT_SHOWN;
  }
  if (isOptIn) {
    return CONTEXT_OPTED_IN;
  }
  return CONTEXT_OPTED_OUT;
};

// Google Sign-In
export const FUNNEL_GOOGLE_V1 = 'google_signin_v1.0';
export const STEP_INTRO_SCREEN = 'intro_screen';
export const CONTEXT_MAP_GOOGLE_LOGIN = {
  [AUTH_OPTIONS_VARIANT_SMS_FB]: 'facebook_sms',
  [AUTH_OPTIONS_VARIANT_GOOGLE]: 'google_only',
  [AUTH_OPTIONS_VARIANT_GOOGLE_SMS]: 'google_sms',
  [AUTH_OPTIONS_VARIANT_GOOGLE_FB_SMS]: 'google_facebook_sms',
};
export const CONTEXT_LINE = 'line';
export const CONTEXT_FB = 'facebook';
export const CONTEXT_GOOGLE = 'google';
export const CONTEXT_SMS = 'sms';
export const ACTION_MORE_OPTIONS = 'more_options';
export const ACTION_TROUBLE_LOGGING_IN = 'trouble_logging_in';

// Identity Flow
export const DECISION_INTERACTIVE_LOGIN: 'interactive' = 'interactive';
export const DECISION_REAUTH: 'reauth' = 'reauth';
export const DECISION_LOGGED_IN: 'logged_in' = 'logged_in';
export const DECISION_YES: 'yes' = 'yes';
export const DECISION_NO: 'no' = 'no';
export const DECISION_SUPPRESSED: 'suppressed' = 'suppressed';
export const DECISION_NOT_SUPPRESSED: 'not_suppressed' = 'not_suppressed';
export const STEP_TOKEN_TYPE: 'token_type' = 'token_type';
export const STEP_AUTH_END: 'auth_end' = 'auth_end';
export const STEP_CAPTCHA_SHOW: 'captcha_show' = 'captcha_show';
export const STEP_CAPTCHA_COMPLETED: 'captcha_completed' = 'captcha_completed';

export type Decision =
  | typeof DECISION_INTERACTIVE_LOGIN
  | typeof DECISION_REAUTH
  | typeof DECISION_LOGGED_IN
  | typeof DECISION_YES
  | typeof DECISION_NO
  | typeof DECISION_SUPPRESSED
  | typeof DECISION_NOT_SUPPRESSED;
